/**
 * Home Page manipulation
 *
 * @since   1.0.0
 * @package uma
 */

(function($) {

	if ( $('body.home').length ) {

		var wrapMe = $('section.solar-solutions .flex-wrapper > div').slice(3);
		wrapMe.wrapAll('<div class="last-of-us"></div>');

	}

	$( document ).ready(function(){
	    // need to have the same with set from JS on both divs. Otherwise it can push stuff around in HTML
	    $('.trp-language-switcher').each(function(index, el){
	        var trp_ls_shortcode_width = $(el).find('.trp-ls-shortcode-language').width() + 5;
	        $(el).find('.trp-ls-shortcode-language').width(trp_ls_shortcode_width);
	        $(el).find('.trp-ls-shortcode-current-language').width(trp_ls_shortcode_width);
	        // We're putting this on display: none after we have it's width.
	        $(el).find('.trp-ls-shortcode-language').hide();
	    });
	});

}(jQuery));
